<template>
    <div class="container">
        <h1>i'm Governance page</h1>
    </div>
</template>
<script>
export default {
    name: 'GovernancePage',
    data() { return {} },
    components: {},
}
</script>